import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import {
  RATE_TYPE_FIXED, RATE_TYPE_PER_MONTH,
   RATE_TYPE_FREE, RATE_TYPE_PER_CLASS, RATE_TYPE_PER_HOUR
} from 'src/app/constants';
import {SEARCH_RESULT_KEYWORDS,SEARCH_RESULT_KEYWORD_CONTENT,
  SEARCH_RESULT_KEYWORD_DESC,SEARCH_RESULT_KEYWORD_DESC_CONTENT,SEARCH_TITLE} from 'src/app/seoconstants';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss']
})
export class SearchResultsComponent implements OnInit {

  category:string;
  category1:string;
  specialityId:string;
  mode:string;
  searchList:any;
  serviceTypeList:any;
  specialityList:[];
  searchlength:number;
  businessName:string;
  specialityName:[];
  businessSpecialityId:string;
  vendorTypeName:any;
  id:number;
  vendorTypeId:any;
  speciallityList:any;
  specialId:string;
  specialityDataList:any;
  venId:string;
  specilityArr:[];
  imgPlaceholder = './assets/images/noimage.png';
  isFilter;
  title:string;
  keywords:string;
  keywordcontent:string;
  desc:string;
  desccontent:string;


  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private titleService: Title, private metaService: Meta
    ) {

      this.category = this.activatedRoute.snapshot.paramMap.get('category');
      
      this.specialityId = this.activatedRoute.snapshot.paramMap.get('specialityId');      
      this.mode = this.activatedRoute.snapshot.paramMap.get('mode');

     }

  ngOnInit() {

    this.title = SEARCH_TITLE;
    this.keywords = SEARCH_RESULT_KEYWORDS;
    this.keywordcontent = SEARCH_RESULT_KEYWORD_CONTENT;
    this.desc = SEARCH_RESULT_KEYWORD_DESC;
    this.desccontent = SEARCH_RESULT_KEYWORD_DESC_CONTENT;

    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      {name: this.keywords, content: this.keywordcontent},
      {name: this.desc, content: this.desccontent},
      {name: 'robots', content: 'index, follow'}
    ]);


    this.isFilter ="0";
    let vendata = {
      token:localStorage.getItem("token_data"),
      userID:localStorage.getItem("userID")
    }
   
    this.apiService.getVenDetails(vendata).subscribe((res:any)=>{     
      this.serviceTypeList = res.data.venDetails.data;     
      this.serviceTypeList.forEach(obj => { 
     
      this.vendorTypeId = obj.id;     

      if( this.vendorTypeId == this.category ){
        this.vendorTypeName = obj.vendorTypeName;       
      }
      
    })        
    
    });

    


    
   let specialData = {
    token:localStorage.getItem("token_data"),
    userID:localStorage.getItem("userID"),
    vendorType:this.category
   }
    this.apiService.getspetialityDetails(specialData).subscribe((res:any)=>{      
      this.speciallityList= res.data.venSplDetails.data;      
      this.speciallityList.forEach(obj1 => {    
       
        this.specialId = obj1.id;      
          
          if(this.specialityId==this.specialId && this.specialId!=""){
            this.specialityName = obj1.specialityName;           
          }   
        })     

    });
    

   if(this.specialityId=="undefined" && this.mode=="undefined"){
   const searchData = {
    lat: null,
    lang: null,
    serviceTypeID: this.category   
   } 
  

   this.apiService.getSearchResults(searchData).subscribe((res:any)=>{   
    this.searchList = res.data.businessData.data.businessDetails;    
    this.businessSpecialityId = res.data.businessData.data.businessDetails.specialityId;    
    this.searchlength = this.searchList.length;
    this.specialityDataList = this.groupBy(res.data.businessData.data.businessSpeciality, 'id'); 
    
    
  });
    }
 else if( this.mode=="undefined"){
  const searchData = {
    lat: null,
    lang: null,
    serviceTypeID: this.category,
    specialityID: this.specialityId   
   }   

   this.apiService.getSearchResults(searchData).subscribe((res:any)=>{
    
    this.searchList = res.data.businessData.data.businessDetails;    
    this.businessSpecialityId = res.data.businessData.data.businessDetails.specialityId;    
    this.searchlength = this.searchList.length;
    this.specialityDataList = this.groupBy(res.data.businessData.data.businessSpeciality, 'id');
    console.log(this.specialityDataList); 
  });
}

else {

  const searchData = {
    lat: null,
    lang: null,
    serviceTypeID: this.category,
    specialityID: this.specialityId,
    mode: this.mode    
   } 
  

   this.apiService.getSearchResults(searchData).subscribe((res:any)=>{    
    this.searchList = res.data.businessData.data.businessDetails;      
    this.businessSpecialityId = res.data.businessData.data.businessDetails.specialityId;    
    this.searchlength = this.searchList.length;   
    this.specialityDataList = this.groupBy(res.data.businessData.data.businessSpeciality, 'id');
     

  });

  



}

 }

 speciallity(){
  
  let specialData = {
   token:localStorage.getItem("token_data"),
   userID:localStorage.getItem("userID"),
   vendorType:this.category
  }
   this.apiService.getspetialityDetails(specialData).subscribe((res:any)=>{
    
     this.speciallityList= res.data.venSplDetails.data;
                      
     this.speciallityList.forEach(function (value, key) {
      
     })

   });

   
 }

 filter(){
  this.isFilter = "1";
 }

 search(){
   
   
   const searchData = {
    lat: null,
    lang: null,
    serviceTypeID: this.category1,
    specialityID: this.specialityId
    
   } 
  

   this.apiService.getSearchResults(searchData).subscribe((res:any)=>{
   
    this.searchList = res.data.businessData.data.businessDetails;  
    
    this.businessSpecialityId = res.data.businessData.data.businessDetails.specialityId;    
    this.searchlength = this.searchList.length;
   
    this.specialityDataList = this.groupBy(res.data.businessData.data.businessSpeciality, 'id');
      
    

  });
 }

 getUsersSpecialities(id) {
  return this.specialityDataList.hasOwnProperty(id) ? this.specialityDataList[id].map(el => el.specialityName).join(', ') : '';
}
groupBy(array, key) {
  // Return the end result
  return array.reduce((result, currentValue) => {
    // If an array already present for key, push it to the array. Else create an array and push the object
    (result[currentValue[key]] = result[currentValue[key]] || []).push(
      currentValue
    );
    // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
    return result;
  }, {}); // empty object is the initial value for result object
};

getRateText(priceRateTypeId) {
  if (!priceRateTypeId) {
    return "";
  }

  if (priceRateTypeId === 1) {
    return RATE_TYPE_FIXED;
  } else if (priceRateTypeId === 2) {
    return RATE_TYPE_PER_MONTH;
  }
  else if (priceRateTypeId === 3) {
    return RATE_TYPE_FREE;
  }
  else if (priceRateTypeId === 4) {
    return RATE_TYPE_PER_CLASS;
  }
  else
    return RATE_TYPE_PER_HOUR;
}
  
  profile(venId){
    this.router.navigateByUrl(`/profile/`+venId);
  }

  getShortName(fullName) {
    return fullName.charAt(0);
  }

  getSpecThumb(specId){
    
    return "https://s3.ap-south-1.amazonaws.com/dev.studented.in/category_speciality/images/" + specId + ".jpg";
  }

}
